import { PageHeader, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import {
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  EditableTableDatePickerItem,
  SegmentedItem
} from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import IconFileXml from "../../../Icons/IconFileXml";
import XmlPrevioCuentasPorCobrar from "./XmlPrevioCuentasPorCobrar/XmlPrevioCuentasPorCobrar";
import { DollarOutlined, EyeOutlined, ScheduleOutlined } from "@ant-design/icons";
import ModalEditarFechas from "../../../Components/ModalEditarFechas";

moment.locale("es");

const {
  EditableRow,
  EditableCell
} = EditableTableDatePickerItem

class CuentasPorCobrar extends Component {
  state = {
    todasCuentasPorCobrar: [],
    todasCuentasPorCobrarCliente: [],
    totalPagar: 0,
    loading: false,
    valor: 3,
    modalXmlPrevio: false,
    ventaSeleccionada: null,
    modalEditarFechas: false,
    rangosLeyenda: [],
    usarColores: false,
    filtroDocumento: "T",
    // Solo con tienda en linea: "todas", "normales" o "ecommerce" (por Venta.ventaOnline)
    filtroVentaOnline: "todas",
  };
  componentDidMount() {
    this.consultarCuentasPorCobrar(this.state.valor);
    this.consultarConfiguracionVencimiento();
  }

  async consultarConfiguracionVencimiento() {
    axios
      .post(
        "empresas/selectConfiguracionVencimiento",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            usarColores: res.data.configuracion.usarColoresVencimiento,
            rangosLeyenda: res.data.configuracion.rangosDiasVencimiento || []
          });
        }
      });
  }

  // Sin tienda en linea no se manda el filtro y el backend consulta igual que siempre
  filtroVentaOnlineParaConsulta(filtroVentaOnline) {
    return this.props.ventaOnline ? filtroVentaOnline : undefined;
  }

  async consultarCuentasPorCobrar(valor, filtroVentaOnline = this.state.filtroVentaOnline) {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentasporcobrar/selectVentas",
        {
          empresaId: this.props.empresaId,
          valor: valor,
          filtroVentaOnline: this.filtroVentaOnlineParaConsulta(filtroVentaOnline),
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          this.setState({ todasCuentasPorCobrar: [] });
        } else {
          let totalPagar = 0;
          this.setState({
            todasCuentasPorCobrar: res.data.map((value) => {
              totalPagar += ((value.totalPagar - value.totalPagado) * value.tipoDeCambio);
              let numero = ''
              if (value.remision) {
                numero += (value.remisionSerie ? value.remisionSerie : 'R') + ' ' + value.remisionNumero
              }
              if (value.factura) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaSerie ? value.facturaSerie : 'F') + ' ' + value.facturaNumero
              }
              const clienteNombre = value.cliente.nombre
                  ? value.cliente.nombre +
                  " " +
                  value.cliente.apellidoPaterno +
                  " " +
                  value.cliente.apellidoMaterno
                  : value.cliente.razonSocial;
              const claveCliente = (value.cliente.nombreComercial || '') + (value.cliente.clave ? ` (${value.cliente.clave})` : '');
              const clienteNombreBuscar = claveCliente ? `${clienteNombre} ${claveCliente}` : clienteNombre;
              return {
                ...value,
                proyectoNombre: value.proyecto.nombre,
                numero,
                clienteNombre: clienteNombre,
                claveCliente: claveCliente,
                clienteRfc: value.cliente.rfc,
                clienteNombreBuscar: clienteNombreBuscar,
                saldoPendiente: value.totalPagar - value.totalPagado,
                accion: {
                  _id: value._id,
                  estadoPago: value.estadoPago,
                  fechaPago: value.fechaPago,
                  fechaVencimiento: value.fechaVencimiento,
                  cuentasXC: value.cuentasXC,
                },
              };
            }),
          });
          this.setState({ totalPagar: dineroDisabledMask(totalPagar) });
        }
      });
  }
  async consultarCuentasPorCobrarCliente(filtroVentaOnline = this.state.filtroVentaOnline) {
    this.setState({ loading: true });
    await axios
      .post(
        "cuentasporcobrar/selectCuentasPCliente",
        {
          empresaId: this.props.empresaId,
          filtroVentaOnline: this.filtroVentaOnlineParaConsulta(filtroVentaOnline),
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          this.setState({ todasCuentasPorCobrarCliente: [] });
        } else {
          let totalPagar = 0;
          this.setState({
            todasCuentasPorCobrarCliente: res.data.map((value) => {
              totalPagar += (value.totalPagar - value.totalPagado)
              const clienteNombre = value.cliente.persona
                ? value.cliente.razonSocial
                : value.cliente.nombre +
                " " +
                value.cliente.apellidoPaterno +
                " " +
                value.cliente.apellidoMaterno;
              //A la clave ponle tambien el nombreComercial
              const claveCliente = (value.cliente.nombreComercial || '') + (value.cliente.clave ? ` (${value.cliente.clave})` : '');
              const clienteNombreBuscar = claveCliente ? `${clienteNombre} ${claveCliente}` : clienteNombre;
              return {
                ...value,
                clienteNombre: clienteNombre,
                clienteNombreBuscar: clienteNombreBuscar,
                clienteRfc: value.cliente.rfc,
                claveCliente: claveCliente,
                saldoPendiente: value.totalPagar - value.totalPagado,
                accion: {
                  _id: value._id,
                  fechaPago: value.fechaPago,
                  nombre: clienteNombre + " - " + value.cliente.rfc,
                  fechaVencimiento: value.fechaVencimiento,
                  formaDePagoId: value.cliente.formaDePagoId
                },
              };
            }),
          });
          this.setState({ totalPagar: dineroDisabledMask(totalPagar) });
        }
      });
  }
  cobrarVenta(id, cheque) {
    this.props.history.push("/panel/cobrarVenta", { id, cheque });
  }
  verCliente(id, nombre, cheque, formaDePagoId) {
    this.props.history.push("/panel/verVentasCliente", { id, nombre, cheque, formaDePagoId });
  }

  cerrarXmlPrevioCuentasPorCobrar() {
    this.setState({ modalXmlPrevio: false })
    const value = this.state.valor
    if (value === 4) {
      this.consultarCuentasPorCobrarCliente()
    } else {
      this.consultarCuentasPorCobrar(value)
    }
    this.setState({ valor: value })
  }

  abrirXmlPrevioCuentasPorCobrar() {
    this.setState({ modalXmlPrevio: true })
  }

  abrirModalEditarFechas(venta) {
    this.setState({
      modalEditarFechas: true,
      ventaSeleccionada: venta,
    });
  }

  cerrarModalEditarFechas(recargar = false) {
    this.setState({
      modalEditarFechas: false,
      ventaSeleccionada: null,
    });

    if (recargar) {
      this.consultarCuentasPorCobrar(this.state.valor);
    }
  }

  render() {
    //Colores fijos para los iconos de las columnas 
    const coloresFijos = [
      'rgba(236, 251, 241, 1)', // Verde claro
      'rgba(223, 247, 230, 1)', // Verde
      'rgba(255, 244, 204, 1)', // Amarillo
      'rgba(255, 226, 204, 1)', // Naranja
      'rgba(255, 214, 214, 1)', // Rojo
    ];
    const estadosLeyendaDinamicos = this.state.usarColores
      ? this.state.rangosLeyenda.map((rango, index) => ({
        color: coloresFijos[index] || 'rgba(200, 200, 200, 1)', // Color por defecto si hay más de 5
        label: rango.nombre,
        key: `rango-${index}`,
        tope: rango.tope
      }))
      : [];

    const isMobile = window.innerWidth <= 1000;
    const fechaVen =
    {
      title: "Vencimiento",
      dataIndex: "fechaVencimiento",
      key: "fechaVencimiento",
      sorter: (a, b) => {
        if (!a.fechaVencimiento && !b.fechaVencimiento) return 0;
        if (!a.fechaVencimiento) return 1;
        if (!b.fechaVencimiento) return -1;
        if (moment(a.fechaVencimiento) < moment(b.fechaVencimiento)) {
          return -1;
        }
        if (moment(a.fechaVencimiento) > moment(b.fechaVencimiento)) {
          return 1;
        }
        return 0;
      },
      render: (value) => value ? moment(value).locale("es").format("L") : "-",
      width: isMobile ? "5%" : "10%",
    }
    const fechaPago =
    {
      title: "Prob. Pago",
      dataIndex: "fechaPago",
      key: "fechaPago",
      sorter: (a, b) => {
        if (!a.fechaPago && !b.fechaPago) return 0;
        if (!a.fechaPago) return 1;
        if (!b.fechaPago) return -1;
        if (moment(a.fechaPago) < moment(b.fechaPago)) {
          return -1;
        }
        if (moment(a.fechaPago) > moment(b.fechaPago)) {
          return 1;
        }
        return 0;
      },
      render: (value) => value ? moment(value).locale("es").format("L") : "-",
      width: isMobile ? "5%" : "10%",
    }


    const columns = this.state.valor === 4
      ? [
        {
          title: "Cliente",
          dataIndex: "clienteNombreBuscar",
          key: "clienteNombreBuscar",
          buscar: "clienteNombreBuscar",
          render: (_, record) => (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontSize: "12px", fontWeight: "bold" }}>{record.clienteNombre}</span>
              <span style={{ fontSize: "12px", color: "#666" }}>{record.claveCliente || "-"}</span>
            </div>
          ),
          width: window.innerWidth >= 1800 ? "18%" : "20%",
          ellipsis: true,
        },
        {
          title: "RFC",
          dataIndex: "clienteRfc",
          key: "clienteRfc",
          buscar: "clienteRfc",
          render: (value) => (
            <div style={{ fontSize: "12px" }}>
              {value}
            </div>
          ),
          width: "8%",
          ellipsis: true,

        },
        {
          title: "Fecha de Vencimiento",
          dataIndex: "fechaPago",
          key: "fechaPago",
          sorter: (a, b) => {
            if (!a.fechaPago && !b.fechaPago) return 0;
            if (!a.fechaPago) return 1;
            if (!b.fechaPago) return -1;
            if (moment(a.fechaPago) < moment(b.fechaPago)) {
              return -1;
            }
            if (moment(a.fechaPago) > moment(b.fechaPago)) {
              return 1;
            }
            return 0;
          },
          render: (value) => value ? moment(value).locale("es").format("DD-MMMM-YYYY") : "-",
          width: isMobile ? "5%" : "12%",
        },
        {
          title: "Total a Pagar / Pagado",
          dataIndex: "totalPagar",
          responsive: ["md"],
          key: "totalPagar",
          sorter: (a, b) => {
            if (a.totalPagar < b.totalPagar) {
              return -1;
            }
            if (a.totalPagar > b.totalPagar) {
              return 1;
            }
            return 0;
          },
          render: (_, record) => (
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                <span>{dineroDisabledMask(record.totalPagar)}</span>
                {record.abreviacionMoneda && <span style={{ fontSize: "12px", color: "#999" }}>{record.abreviacionMoneda}</span>}
              </div>
              <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                <span>{dineroDisabledMask(record.totalPagado)}</span>
                {record.abreviacionMoneda && <span style={{ fontSize: "12px" }}>{record.abreviacionMoneda}</span>}
              </div>
            </div>
          ),
          width: "13%",
          align: "right",
        },
        {
          title: "Total Pagado",
          dataIndex: "totalPagado",
          key: "totalPagado",
          sorter: (a, b) => {
            if (a.totalPagado < b.totalPagado) {
              return -1;
            }
            if (a.totalPagado > b.totalPagado) {
              return 1;
            }
            return 0;
          },
          responsive: [],
          width: 0,
        },
        {
          title: "Saldo Pendiente",
          dataIndex: "saldoPendiente",
          key: "saldoPendiente",
          sorter: (a, b) => {
            if (a.saldoPendiente < b.saldoPendiente) {
              return -1;
            }
            if (a.saldoPendiente > b.saldoPendiente) {
              return 1;
            }
            return 0;
          },
          render: (_, record) => (
            <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.saldoPendiente)}</span>
              {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
            </div>
          ),
          width: "10%",
          align: "right",
        },
        {
          title: "Vencimiento",
          dataIndex: "accion",
          responsive: ["md"],
          key: "vencimiento",
          render: (value, record, index) => {
            if (value.fechaVencimiento && moment() > moment(value.fechaVencimiento)) {
              return (
                <Tag key={`vencido-${index}`} color="red" className="square-tag">
                  Vencido {moment().diff(moment(value.fechaVencimiento), 'days')} días
                </Tag>
              );
            }
            return null;
          },
          width: "10%",
        },
        {
          title: "Acción",
          dataIndex: "accion",
          key: "accion",
          align: "center",
          width: "10%",
          onHeaderCell: () => ({
            style: { textAlign: 'center', padding: '4px' }
          }),
          onCell: () => ({
            className: "acciones-sin-hover",
            style: { textAlign: 'center', padding: '4px' }
          }),
          render: (value, record, index) => {
            let buttons = [];

            const puedeCobrar = this.props.permisoCobrar;
            if (puedeCobrar) {
              buttons.push(
                <Tooltip key={`cobrar-${index}`} title="Cobrar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    amarillo
                    icon={<DollarOutlined />}
                    onClick={() => this.verCliente(value._id, value.nombre, value.cheque, value.formaDePagoId)}
                  >
                  </ButtonItem>
                </Tooltip>
              );
            }

            return <div className="acciones-container">{buttons}</div>;
          },
        },
      ]
      : [
        {
          title: "Código",
          dataIndex: "numero",
          responsive: ["md"],
          key: "numero",
          sorter: (a, b) => {
            if (a.numero < b.numero) {
              return -1;
            }
            if (a.numero > b.numero) {
              return 1;
            }
            return 0;
          },
          buscar: "numero",
          render: (_, record) => (
            <div>
              <div style={{ fontSize: "12px" }}>
                {record.numero}
                {this.props.ventaOnline && record.ventaOnline && (
                  <Tag color="purple" className="square-tag" style={{ fontSize: "10px", marginLeft: 6 }}>
                    Ecommerce
                  </Tag>
                )}
              </div>
              {record.fechaVenta && (
                <div style={{ fontSize: "12px", color: "#666" }}>
                  Fecha: {moment(record.fechaVenta).format("DD/MM/YY")}
                </div>
              )}
            </div>
          ),
          width: "17%",
        },
        {
          title: "Proyecto",
          dataIndex: "proyectoNombre",
          responsive: ["md"],
          key: "proyectoNombre",
          sorter: (a, b) => {
            if (a.proyectoNombre < b.proyectoNombre) {
              return -1;
            }
            if (a.proyectoNombre > b.proyectoNombre) {
              return 1;
            }
            return 0;
          },
          buscar: "proyectoNombre",
          width: "10%",
        },
        {
          title: "Cliente",
          dataIndex: "clienteNombreBuscar",
          key: "clienteNombreBuscar",
          render: (_, record) => (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontSize: "12px", fontWeight: "bold" }}>{record.clienteNombre}</span>
              <span style={{ fontSize: "12px", color: "#666" }}>{record.claveCliente || "-"}</span>
            </div>
          ),
          sorter: (a, b) => {
            if (a.clienteNombreBuscar < b.clienteNombreBuscar) {
              return -1;
            }
            if (a.clienteNombreBuscar > b.clienteNombreBuscar) {
              return 1;
            }
            return 0;
          },
          buscar: "clienteNombreBuscar",
          width: isMobile ? "13%" : "23%",
        },
        fechaVen,
        fechaPago,
        {
          title: "T.C.",
          dataIndex: "tipoDeCambio",
          key: "tipoDeCambio",
          responsive: ["md"],
          width: "5%",
        },
        {
          title: "Total a Cobrar / Cobrado",
          dataIndex: "totalPagar",
          responsive: ["md"],
          key: "totalPagar",
          sorter: (a, b) => {
            if (a.totalPagar < b.totalPagar) {
              return -1;
            }
            if (a.totalPagar > b.totalPagar) {
              return 1;
            }
            return 0;
          },
          render: (_, record) => (
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                <span>{dineroDisabledMask(record.totalPagar)}</span>
                {record.moneda && <span style={{ fontSize: "12px", color: "#999" }}>{record.moneda}</span>}
              </div>
              <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                <span>{dineroDisabledMask(record.totalPagado)}</span>
                {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
              </div>
            </div>
          ),
          buscar: "totalPagar",
          width: "15%",
          align: "right",
        },
        {
          title: "Total Cobrado",
          dataIndex: "totalPagado",
          key: "totalPagado",
          sorter: (a, b) => {
            if (a.totalPagado < b.totalPagado) {
              return -1;
            }
            if (a.totalPagado > b.totalPagado) {
              return 1;
            }
            return 0;
          },
          buscar: "totalPagado",
          responsive: [],
          width: 0,
        },
        {
          title: "Saldo Pendiente",
          dataIndex: "saldoPendiente",
          key: "saldoPendiente",
          sorter: (a, b) => {
            if (a.saldoPendiente < b.saldoPendiente) {
              return -1;
            }
            if (a.saldoPendiente > b.saldoPendiente) {
              return 1;
            }
            return 0;
          },
          render: (_, record) => (
            <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.saldoPendiente)}</span>
              {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
            </div>
          ),
          width: isMobile ? "31%" : "13%",
          align: "right",
        },
        {
          title: "Estado",
          dataIndex: "estadoPago",
          responsive: ["md"],
          key: "estadoPago",
          render: (value, record, index) => {
            if (value === 0) {
              return (
                <Tag key={index.toString()} color="blue" className="square-tag">
                  No cobrada
                </Tag>
              );
            }
            if (value === 2) {
              return (
                <Tag key={index.toString()} color="orange" className="square-tag" style={{ fontSize: "10px" }}>
                  Cobrado parcialmente
                </Tag>
              );
            }
          },
          width: "14%",
        },
        {
          title: "Vencimiento",
          dataIndex: "accion",
          responsive: ["md"],
          key: "vencimiento",
          render: (value, record, index) => {
            if (!value.fechaVencimiento) {
              return null;
            }
            if (value.cuentasXC && moment().diff(moment(value.fechaVencimiento), 'days') >= 0) {
              return (
                <Tag key={index.toString()} color="blue" className="square-tag3" style={{ fontSize: "11px" }}>
                  PUE {moment().diff(moment(value.fechaVencimiento), 'days')} días
                </Tag>
              );
            } else if (moment() > moment(value.fechaVencimiento)) {
              return (
                <Tag key={index.toString()} color="red" className="square-tag3" style={{ fontSize: "11px" }}>
                  PPD {moment().diff(moment(value.fechaVencimiento), 'days')} días
                </Tag>
              );
            }
            return null;
          },
          width: "12%",
        },
        {
          title: "Acción",
          dataIndex: "accion",
          key: "accion",
          align: "center",
          width: isMobile ? "20%" : "12%",
          onHeaderCell: () => ({
            style: { textAlign: 'center', padding: '4px' }
          }),
          onCell: () => ({
            style: { textAlign: 'center', padding: '4px' }
          }),
          render: (value, record, index) => {
            let buttons = [];
            const puedeEditarFechas = !(record.contado === 2);
            if (this.props.permisoCambiarFecha) {
              buttons.push(
                <Tooltip key={`fechas-${index}`} title={"Modificar fechas"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<ScheduleOutlined />}
                    onClick={() => this.abrirModalEditarFechas(record)}
                    disabled={puedeEditarFechas}
                  >
                  </ButtonItem>
                </Tooltip>
              )
            }

            const puedeCobrar = (value.estadoPago === 0 || value.estadoPago === 2) && this.props.permisoCobrar;
            buttons.push(
              <Tooltip key={`cobrar-${index}`} title={puedeCobrar ? "Cobrar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  amarillo
                  icon={<DollarOutlined />}
                  onClick={() => puedeCobrar && this.cobrarVenta(value._id, value.cheque)}
                  disabled={!puedeCobrar}
                >
                </ButtonItem>
              </Tooltip>
            );

            const puedeVerFactura = (value.estadoPago === 0 || value.estadoPago === 2) && this.props.permisoCobrar;
            buttons.push(
              <Tooltip key={`ver-${index}`} title={puedeVerFactura ? "Ver Factura" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  azul
                  icon={<EyeOutlined />}
                  onClick={() => puedeVerFactura && this.props.history.push("/panel/verVenta", { id: record._id })}
                  disabled={!puedeVerFactura}
                >
                </ButtonItem>
              </Tooltip>
            );


            return <div className="acciones-container">{buttons}</div>;
          },
        },

      ];

    const tituloVentaOnline = this.props.ventaOnline
      ? { normales: " Normales", ecommerce: " Ecommerce" }[this.state.filtroVentaOnline] || ""
      : "";

    return (
      <>
        <PageHeader
          title={"Cuentas por Cobrar" + tituloVentaOnline + ": " + this.state.totalPagar}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && this.props.ventaOnline &&
                <SegmentedItem
                  options={[{ label: 'Todo', value: 'todas' }, { label: 'Normales', value: 'normales' }, { label: 'Ecommerce', value: 'ecommerce' }]}
                  onChange={(filtroVentaOnline) => {
                    if (this.state.valor === 4) {
                      this.consultarCuentasPorCobrarCliente(filtroVentaOnline)
                    } else {
                      this.consultarCuentasPorCobrar(this.state.valor, filtroVentaOnline)
                    }
                    this.setState({ filtroVentaOnline })
                  }}
                  value={this.state.filtroVentaOnline}
                />
              }
              {window.innerWidth > 1000 && this.state.valor !== 4 &&
                <SegmentedItem
                  options={[{ label: 'F', value: 'F' }, { label: 'R', value: 'R' }, { label: 'T', value: 'T' }]}
                  onChange={(value) => this.setState({ filtroDocumento: value })}
                  value={this.state.filtroDocumento}
                />
              }
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[{ label: 'Todas', value: 3 }, { label: 'Cobrado Parcialmente', value: 2 }, { label: 'Agrupar por Cliente', value: 4 }]}
                  onChange={(value) => {
                    if (value === 4) {
                      this.consultarCuentasPorCobrarCliente()
                    } else {
                      this.consultarCuentasPorCobrar(value)
                    }
                    this.setState({ valor: value })
                  }}
                  value={this.state.valor}
                />
              }
              {this.props.cargarXmlPrevio &&
                <ButtonItem className="botonAgregar" type="primary" onClick={() => this.abrirXmlPrevioCuentasPorCobrar()} blanco icon={<IconFileXml />}>Xml previo</ButtonItem>
              }
            </>
          }
        />
        <TableItem
          components={{
            body: {
              row: EditableRow,
              cell: EditableCell,
            },
          }}
          loading={this.state.loading}
          size="small"
          dataSource={
            this.state.valor === 4
              ? this.state.todasCuentasPorCobrarCliente
              : this.state.todasCuentasPorCobrar.filter((value) => {
                if (this.state.filtroDocumento === 'F') return !!value.factura;
                if (this.state.filtroDocumento === 'R') return !!value.remision;
                return true;
              })
          }
          columns={columns}
          estadosLeyenda={estadosLeyendaDinamicos}
          pagination={false}
          onRow={(record) => ({
            onDoubleClick: () => {
              if (this.state.valor === 4) {
                this.verCliente(record._id, record.clienteNombre, record.cheque, record.accion.formaDePagoId)
              } else {
                this.cobrarVenta(record._id, record.cheque);
              }
            },
          })}
        />
        <XmlPrevioCuentasPorCobrar
          visible={this.state.modalXmlPrevio}
          cerrarXmlPrevioCuentasPorCobrar={this.cerrarXmlPrevioCuentasPorCobrar.bind(this)}
        />
        <ModalEditarFechas
          visible={this.state.modalEditarFechas}
          venta={this.state.ventaSeleccionada}
          onCancel={() => this.cerrarModalEditarFechas(false)}
          onSuccess={() => this.cerrarModalEditarFechas(true)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    cargarXmlPrevio: state.empresa.cargarXmlPrevio,
    ventaOnline: state.empresa.ventaOnline,
    permisoCobrar:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615cbbc8f30e81b54183cf57"
      )?.activado,
    permisoCambiarFecha:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472e5f74b2da7c85c1a8d18"
      )?.activado,
  };
};

export default connect(mapStateToProps)(CuentasPorCobrar);
